export enum StorageRecoveryStatus {
    FAILED = 'FAILED',
    NOT_NEEDED = 'NOT_NEEDED',
    SUCCEEDED = 'SUCCEEDED',
}

export interface IStorage {
    setBool: (key: string, value: boolean) => void;
    getBool: (key: string) => boolean | null | undefined;
    setString: (key: string, value: string) => void;
    getString: (key: string) => string | null | undefined;
    removeItem: (key: string) => void;
    clearAll: () => void;
    getRecoveryStatus: () => StorageRecoveryStatus;
}
